export default {
  new: {
    title: 'Nova fatura',
    create: 'Criar fatura',
    import: 'Importar fatura'
  },
  financing: 'Financiamento',
  agenda: 'Agenda',
  configuration: {
    title: 'Configuração',
    companyData: 'Dados da empresa',
    users: 'Gestão de utilizadores',
    notification: 'Notificações',
    invoiceFormat: 'Formato de fatura',
    keys: 'Integração WS',
    catalog: 'Catálogo'
  },
  help: {
    title: 'Ajuda',
    manual: 'Manual de utilizador',
    video: 'Vídeo tutorial',
    support: 'Suporte técnico',
    about: 'Acerca de...',
    sefTicketbaiData: 'Acerca de SEF-TicketBAI',
    verifactuStatement: 'Declaração de responsabilidade VERIFACTU'
  },
  verifactu: {
    title: 'Verifactu',
    requerimiento: 'Requerimento',
    enviadas: 'Enviadas',
    comprobarHuella: 'Verificar hash',
    exportarRegistros: 'Exportar registos'
  },
  multiCompany: {
    title: 'MultiEmpresa'
  },
  header: {
    nif: 'Razão social (NIF)',
    language: 'Idioma',
    freeAccount: 'Conta gratuita',
    proAccount: 'Conta PRO',
    contract: 'Contratar',
    proFunctionalities: {
      title: 'Funcionalidades Pro',
      subtitle: 'faturas ilimitadas',
      func1: 'Emite e recebe um número ilimitado de faturas eletrônicas para AAPP, clientes e fornecedores',
      func2: 'Converte, importa e exporta faturas em diferentes formatos compatíveis',
      func3: 'Utilizadores ilimitados para gerir o sistema',
      func4: 'Integração via API com a estrutura administrativa',
      func5: 'Custódia das faturas eletrônicas originais durante o tempo legalmente necessário',
      func6: 'Envio de notificações de acompanhamento em tempo real do estado das faturas',
      func7: 'Comprovante de envio, recepção e impressão personalizado',
      func8: 'Formação inicial',
      func9: 'Suporte técnico telefônico',
      subscription: 'Assinatura premium',
      success: 'Sua solicitação está sendo processada, em breve será contactado.',
      error: 'Erro. Por favor, tente mais tarde ou entre em contato conosco em:',
      close: 'Fechar'
    }
  }
}
